/**
 * Web Style Import
 *
 */

import './style/dnb-drawer-list.scss'
